export default "__VITE_ASSET__SmOCFuyQ__"